import { MantineThemeOverride } from '@mantine/core';

export type TextInputTheme = NonNullable<MantineThemeOverride['components']>['TextInput'];

export const TextInput: TextInputTheme = {
  // todo: define
};
